import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "thanks-order",
    data() {
        return {
            orderResult: JSON.parse(localStorage.getItem("orderResult")),
            currentBranch: "",
        };
    },
    created() {
        this.fetchBranches();
        this.currentBranch = JSON.parse(localStorage.getItem("branchId"));
    },
    computed: {
        ...mapGetters({
            // orderResult: 'basket/orderResult',
            branches: "branches/branchesList",
            getFilialList: `deliveryMethods/getFilialList`,
            orderResponse: "basket/orderResponse",
        }),
        getFilial() {
            let filial = JSON.parse(localStorage.getItem("branchId"));
            return this.$t("cityPrefix") + ". " + (filial?.city_name || 'Кременчук') + ", " + (filial.street || 'вул. Лікаря Богаєвського, 29');
        },
        dateOfDelivery() {
            // var current = new Date();
            // console.log(parseInt(current.getHours()))
            // if(false){
            //     let start = moment(this.orderResult.delivery_date).format('MM-DD-YYYY')
            //     return start
            // }else{
            let start = moment(this.orderResult.delivery_date)
                .add(1, "d")
                .format("MM-DD-YYYY");
            return start;
            // }
        },

        getDelivery() {
            // let currentFilial
            // this.getFilialList.forEach(filial=> currentFilial = filial.address)
            // this.orderResult.delivery.method.id === 1 ? currentFilial : currentFilial = this.orderResult.delivery.method.title
            // let address = this.orderResult.delivery.address.split(' , ');
            // return address, currentFilial
            let filial = JSON.parse(localStorage.getItem("branchId"));
            let currentFilial = this.$t("cityPrefix") + ". " + filial.city_name + ", " + filial.street;

            // this.getFilialList.forEach(filial => currentFilial = filial.address)
            this.orderResult.data.data.delivery.method.id === 1
                ? currentFilial
                : (currentFilial = this.orderResult.data.data.delivery.method.title);
            let address = this.orderResult.data.data.delivery.address.split(" , ");
            return address, currentFilial;
        },
        getFormatAmount() {
            let totalSum = this.orderResult.total_sum;

            if (isNaN(parseFloat(totalSum))) {
                return totalSum;
            }
            let formatter = new Intl.NumberFormat("en-US", {
                style: "decimal",
                maximumFractionDigits: 2,
            });
            return formatter.format(totalSum).replace(/,/g, " ");
        },
    },
    methods: {
        ...mapActions({
            fetchBranches: "branches/GET_BRANCHES",
        }),
        goToProfile() {
            this.$router.push({ name: "profile" });
        },
    },
};
